export default "__VITE_ASSET__CYF0iXfn__"